'use client';
var classes = {"root":"m_7485cace"};

export { classes as default };
//# sourceMappingURL=Container.module.css.mjs.map
